export type ICTAKEYS =
    | 'PAST_VISITS'
    | 'MCERT'
    | 'SEND_ATTACHMENT'
    | 'REFER'
    | 'ADD_ADDRESS'
    | 'ARCHIVE'
    | 'MERGE_PROFILE'
    | 'PRINT_LABEL';

export const GLOBAL_SEARCH_PRINT = 'GLOBAL_SEARCH_PRINT';
